import { useState, useRef, useEffect } from 'react';
import './App.css';
import { ReactComponent as MenosIcon } from './images/btn-menos.svg';
import { ReactComponent as MaisIcon } from './images/btn-mais.svg';

function App() {
  const [recipiente, setRecipiente] = useState(1);
  const [diluicao, setDiluicao] = useState(2);
  const [qtdeDiluicoes, setQtdeDiluicoes] = useState(1);
  const [undMedida, setUndMedida] = useState('L');
  const campos = useRef(null);
  const resultados = useRef(null);
  const [dragActive, setDragActive] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  const diluicoes = [+diluicao];

  useEffect(() => {
    validaCampos();

    resultados.current.getBoundingClientRect().width < resultados.current.scrollWidth ? setDragActive(true) : setDragActive(false);
  }, [recipiente, diluicao, qtdeDiluicoes]);

  const validaCampos = () => {
    recipiente > 0 ? campos.current.querySelector('fieldset:first-child').classList.remove('erro') : campos.current.querySelector('fieldset:first-child').classList.add('erro');

    diluicao > 1 ? campos.current.querySelector('fieldset:nth-child(2)').classList.remove('erro') : campos.current.querySelector('fieldset:nth-child(2)').classList.add('erro');

    qtdeDiluicoes < 1 ? campos.current.querySelector('fieldset:last-child').classList.add('erro') : campos.current.querySelector('fieldset:last-child').classList.remove('erro');
  }

  const cleanQtde = (campo) => {
    campo.value = campo.value.replace(/,/g, '');
  }

  const calcDiluicoes = () => {
    if (recipiente > 0 && diluicao > 1 && qtdeDiluicoes >= 1) {
      for (let n = 1; n < qtdeDiluicoes; n++) {
        diluicoes.push(diluicao * diluicoes[n - 1]);
      }
    }
  }

  const changeValue = (campo, btn) => {
    if (btn === 'mais') {
      campo === 'diluicao' ? setDiluicao(+diluicao + 1) : setQtdeDiluicoes(+qtdeDiluicoes + 1);
    } else if (btn === 'menos') {
      campo === 'diluicao' ? setDiluicao(+diluicao - 1) : setQtdeDiluicoes(+qtdeDiluicoes - 1);
    }
  }

  const scrollStart = (e) => {
    setIsDragging(true);
    setStartX(e.pageX - resultados.current.offsetLeft);
    setScrollLeft(resultados.current.scrollLeft);
    e.preventDefault();
  };
  
  const scrollMove = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - resultados.current.offsetLeft;
    const walk = (x - startX) * 2; // scroll speed
    resultados.current.scrollLeft = scrollLeft - walk;
  };
  
  const scrollEnd = () => {
    setIsDragging(false);
  };

  return (
    <div className="App">
      <section className='campos wrapper' ref={campos}>
        <fieldset>
          <div className='field-heading'>
            <legend>Tamanho do recipiente</legend>

            <p className='msg-erro'><small>O tamanho do recipiente deve ser superior a 0 (zero).</small></p>
          </div>
          
          <div className='fields'>
            <input type="number" min="0" name="recipiente" id='recipiente' value={recipiente} onChange={({target}) => setRecipiente(target.value)} aria-label='Insira o tamanho do recipiente' />

            <select name="unidade" id='unidade' value={undMedida} onChange={({target}) => setUndMedida(target.value)} title='Insira a unidade de medida usada'>
              <option value="L">L</option>
              <option value="mL">mL</option>
              <option value="μL">μL</option>
            </select>
          </div>
        </fieldset>

        <fieldset>
          <div className='field-heading'>
            <legend>Fator de diluição</legend>

            <p className='msg-erro'><small>O fator de diluição deve ser superior a 1.</small></p>
          </div>

          <div className='fields'>
            <input type="number" min="1" name="diluicao" id='diluicao' value={diluicao} onChange={({target}) => setDiluicao(target.value)} aria-label='Insira o fator de diluição a ser usado' />

            <button className='sinal' aria-label={'Diminuir o fator de diluição para ' + (+diluicao - 1)} disabled={+diluicao > 2 ? false : true} onClick={({target}) => changeValue('diluicao', 'menos')}><MenosIcon /></button>

            <button className='sinal' aria-label={'Aumentar o fator de diluição para ' + (+diluicao + 1)} onClick={({target}) => changeValue('diluicao', 'mais')}><MaisIcon /></button>
          </div>
        </fieldset>

        <fieldset>
          <div className='field-heading'>
            <legend>Quantidade de diluições</legend>

            <p className='msg-erro'><small>A quantidade de diluições deve ser superior a 0.</small></p>
          </div>

          <div className='fields'>
            <input type="number" min="1" name="qtdeDiluicoes" id='qtdeDiluicoes' value={qtdeDiluicoes} onKeyUp={({target}) => cleanQtde(target)} onChange={({target}) => setQtdeDiluicoes(target.value)} aria-label='Insira a quantidade de diluições a serem feitas' />

            <button className='sinal' aria-label={'Diminuir a quantidade de diluições para ' + (+qtdeDiluicoes - 1)} disabled={+qtdeDiluicoes > 1 ? false : true} onClick={({target}) => changeValue('qtdeDiluicoes', 'menos')}><MenosIcon /></button>

            <button className='sinal' aria-label={'Aumentar a quantidade de diluições para ' + (+qtdeDiluicoes + 1)} onClick={({target}) => changeValue('qtdeDiluicoes', 'mais')}><MaisIcon /></button>
          </div>
        </fieldset>
      </section>

      {calcDiluicoes()}

      <section className='resultados'>
        <h2>Resultado do cálculo</h2>

        <div className={dragActive ? 'scrollable' : ''} ref={resultados} onMouseDown={scrollStart} onMouseMove={scrollMove} onMouseUp={scrollEnd} onMouseLeave={scrollEnd}>
          <table cellPadding='0' cellSpacing='0'>
            <thead>
              <tr>
                <td></td>
                {diluicoes.map((item, index) =><th scope='column' key={item} aria-label={(index + 1) + 'ª diluição'}><span>{index + 1}ª</span></th>)}
              </tr>
            </thead>
            <tbody>
              <tr>
                <th scope='row'>Diluição</th>
                {diluicoes.map(item =><td key={item}>1:{Number.isInteger(item) ? item : item.toLocaleString('pt-BR')}</td>)}
              </tr>
            </tbody>
          </table>
        </div>

        <table cellPadding='0' cellSpacing='0'>
          <thead>
            <tr>
              <th scope='col' colSpan='2'>Volumes por etapa</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th scope='row'>Amostra</th>
              <td>{Number.isInteger(recipiente / diluicoes[0]) ? `${recipiente / diluicoes[0]} ${undMedida}` : `${(recipiente / diluicoes[0]).toLocaleString('pt-BR', {maximumSignificantDigits: 3})} ${undMedida}`}</td>
            </tr>
            <tr>
              <th scope='row'>Diluente</th>
              <td>{Number.isInteger(recipiente - (recipiente / diluicoes[0])) ? `${recipiente - (recipiente / diluicoes[0])} ${undMedida}` : `${(recipiente - (recipiente / diluicoes[0])).toLocaleString('pt-BR', {maximumSignificantDigits: 3})} ${undMedida}`}</td>
            </tr>
          </tbody>
        </table>
      </section>
    </div>
  );
}

export default App;
